import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[app-mobile-input]',
  standalone: false
})
export class MobileInputDirective {
  private el!: HTMLInputElement;
  @Input() allowDialCode = true;
  @Input() allowParentheses = false;
  constructor(elementRef: ElementRef) {
    this.el = elementRef.nativeElement;
    this.el.setAttribute('autocomplete', 'false');
  }
  // On Focus remove all non-digit or decimal separator values
  @HostListener('focus', ['$event.target.value'])
  onfocus() {
    this.el.select();
  }

  // Prevent user from pasting data with alphabet
  @HostListener('paste', ['$event'])
  onPaste(event: any) {
    var clipData = event.clipboardData?.getData('text');

    if (clipData) {
      const alphaRegex = /[a-zA-Z]/;
      var isInvalid = alphaRegex.test(clipData);
      if (isInvalid) event.preventDefault();
    } else {
      event.preventDefault();
    }
  }

  // Prevent user to enter anything but digits and decimal separator
  @HostListener('keydown', ['$event'])
  onKeyDown(event: any) {
    const dashRegex = /^[0-9]{2,3}$/;
    if (event.ctrlKey || event.metaKey) return;
    const key = event.which || event.keyCode || 0;
    if (
      key === 8 || // Backspace
      key === 9 || // Tab
      key === 46 || // Del
      key === 37 || // Left arrow
      key === 39 || // Right arrow
      ((key === 109 || key === 189) && dashRegex.test(event.target.value)) || // Dash
      (this.allowDialCode && event.key === '+') || // Symbol '+'
      (this.allowParentheses && event.key === '(') || // Symbol '(' when allowed
      (this.allowParentheses && event.key === ')') || // Symbol ')' when allowed
      (!!!event.shiftKey && key >= 47 && key <= 57) || // Number Key
      (key >= 96 && key <= 105) // NumPad
    ) {
      return;
    } else {
      event.preventDefault();
    }
  }

  @HostListener('keyup', ['$event'])
  onKeyUp(event: any) {
    var value = event.target.value;

    if (this.allowDialCode && this.allowParentheses) {
      value = value.replaceAll(/[^\(\)\+\d]+/g, '');
    } else if (this.allowDialCode) {
      value = value.replaceAll(/[^\+\d]+/g, '');
    } else if (this.allowParentheses) {
      value = value.replaceAll(/[^\(\)\d]+/g, '');
    } else {
      value = value.replaceAll(/[^\d]+/g, '');
    }

    event.target.value = value;
    return false;
  }
}
